<template>
    <div class="offer-presets-admin">
        <v-btn-toggle
            v-model="activeSection"
            class="offer-presets-admin__sections"
            density="compact"
            variant="text"
            color="primary"
            mandatory
        >
            <v-btn
                v-for="section in sections"
                :key="section.id"
                :value="section.id"
                :disabled="!section.enabled"
            >
                {{ toSentenceCase($t(section.labelKey)) }}
            </v-btn>
        </v-btn-toggle>
        <div class="offer-presets-admin__content">
            <component :is="activeComponent" v-if="activeComponent" />
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { toSentenceCase } from '@/js/utils/string-utils';

const activeSection = ref('presets');
const sections = [
    {
        id: 'presets',
        labelKey: 'admin.offerPresets.sections.presets',
        component: 'offer-presets-list',
        enabled: true,
    },
    {
        id: 'priceTags',
        labelKey: 'admin.offerPresets.sections.priceTags',
        component: 'offer-presets-list',
        enabled: false,
    },
];
const activeComponent = computed(
    () => sections.find(section => section.id === activeSection.value && section.enabled)?.component
);
</script>

<style scoped lang="scss">
.offer-presets-admin {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    height: 100%;
    min-height: 0;
    padding: 1.6rem 0 2rem;
    font-size: 1.4rem;
    background-color: #fff;

    &__sections {
        flex: 0 0 auto;
        align-self: flex-start;

        :deep(.v-btn) {
            font-size: 1.4rem;
            letter-spacing: normal;
            text-transform: none;
        }
    }

    &__content {
        display: flex;
        flex: 1 1 0;
        flex-direction: column;
        min-height: 0;
    }
}
</style>
